import {Component, OnInit} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {DashboardService} from '../services/dashboard.service';
import {Ordered} from '../models/ordered';

//API Key= AIzaSyAYk_5v3iYZX5w884VtgSvOr_l70ZE-STI

// import {GoogleChartInterface} from 'ng2-google-charts/google-charts-interfaces';
import {Product} from '../models/product';
import {ProductService} from '../services/product.service';
import {OrderedService} from '../services/ordered.service';
import {CalableMemberService} from '../services/calable-member.service';
import {MemberTempService} from '../services/member-temp.service';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {MemberChangedDialogComponent} from './dialogs/member-changed-dialog/member-changed-dialog.component';
import {FormGroup} from '@angular/forms';
import {MemberService} from '../services/member.service';
import {AnnotationService} from '../services/annotation.service';
import {Annotation} from '../models/annotatios';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MemberAnnotationDialogComponent} from '../member/dialogs/member-annotation-dialog/member-annotation-dialog.component';
import {CheckAgendaService} from '../services/check-agenda.service';
import {MemberSiteChangedDialogComponent} from './dialogs/member-site-changed-dialog/member-site-changed-dialog.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.scss' ]
})
export class DashboardComponent implements OnInit {

  public arrayAnnotationPendings: any[] = []

  public arrayMembers: any[] = []

  public arrayProducts: Product[] = []

  public arrayOrders: Ordered[] = [];

  public origins: any;

  public title: any;
  public type: any;
  public data: any;
  public columnNames: any;
  public options: any;
  public width: any;
  public height: any;

  public admCount: number;
  public siteCount: number;
  public androidCount: number;
  public iosCount: number;

  // public pieCharts: GoogleChartInterface[] = [];

  public selectedProduct: any = {};

  public dataSourceMemberTemp: MatTableDataSource<any>
  public dataSourceMemberTempMoved: MatTableDataSource<any>
  public displayedColumnsMemberTemp: string[] = [ 'mt_updatedDate', 'mt_name', 'edit' ];

  dialogRef: any;

  public annotationDataSource: MatTableDataSource<any>
  public displayedAnnotationColumns: string[] = [ 'date', 'text', 'edit', 'delete' ];

  public lastesdOrdersDataSource: MatTableDataSource<any>
  public lastesdOrdersColumns: string[] = [ 'date', 'member', 'product', 'origin', 'type', 'total' ];

  public changesMembnersDataSource: MatTableDataSource<any>
  public changesMermbersColumns: string[] = [ 'date', 'name', 'edit' ];

  constructor (
    public _memberService: MemberService,
    public _calableMemberService: CalableMemberService,
    public _authService: AuthService,
    public _dashService: DashboardService,
    public _productService: ProductService,
    public _orderedService: OrderedService,
    public _memberTempService: MemberTempService,
    public _annotationService: AnnotationService,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    private _checkAgendaService: CheckAgendaService
  ) {



  }

  ngOnInit () {

    //  this._dashService.getAllOrigins()
    //  this._dashService.getAllValues()
    //  this._dashService.getAllCategories()

    this.loadProducts()
    this.getPendingAnnotations()
    this.loadMemberTempDataChanged();
    this.loadLastTwoDaysOrders();
    this.getMembersDataChanges();
  }

  loadLastTwoDaysOrders () {
    this._orderedService.loadLastTwoDaysOrder()
      .subscribe((result) => {

        const array: any[] = [];

        result.forEach(async (item) => {
          const dt: any = item.payload.doc.data().date;
          array.push({
            'date': dt.toDate(),
            'member_name': item.payload.doc.data().member_name,
            'product_name': item.payload.doc.data().product_name,
            'origin': item.payload.doc.data().origin,
            'type': item.payload.doc.data().payment_type,
            'total': item.payload.doc.data().total
          })
          this.lastesdOrdersDataSource = new MatTableDataSource(array);
        })
      })
  }


  loadMemberTempDataChanged () {

    // console.log('loadMemberTempDataChanged')

    this._memberTempService.selectChanged()
      .subscribe((result) => {
        let array: any[] = []
        let arrayMoved: any[] = []

        result.forEach((item) => {

          if (item.payload.doc.data().moved) {
            arrayMoved.push({
              'id': item.payload.doc.id,
              'name': item.payload.doc.data().name,
              'text': item.payload.doc.data().text,
              'image': item.payload.doc.data().image,
              'changed': item.payload.doc.data().changed,
              'updated': item.payload.doc.data().updated,
              'moved': item.payload.doc.data().moved,
              'dateCreated': item.payload.doc.data().dateCreated,
              'dateUpdated': item.payload.doc.data().dateUpdated,
              'comments': item.payload.doc.data().comments,
            })
          } else {
            array.push({
              'id': item.payload.doc.id,
              'name': item.payload.doc.data().name,
              'text': item.payload.doc.data().text,
              'image': item.payload.doc.data().image,
              'changed': item.payload.doc.data().changed,
              'updated': item.payload.doc.data().updated,
              'moved': item.payload.doc.data().moved,
              'dateCreated': item.payload.doc.data().dateCreated,
              'dateUpdated': item.payload.doc.data().dateUpdated,
              'comments': item.payload.doc.data().comments,
            })
          }
          this.dataSourceMemberTemp = new MatTableDataSource(array);
          this.dataSourceMemberTempMoved = new MatTableDataSource(arrayMoved);
        })
      })
  }

  openDialogMemberChanged (element) {

    this.dialogRef = this.dialog.open(MemberChangedDialogComponent, {
      maxWidth: '600px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: element
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ];
        const formData: FormGroup = response[ 1 ];

        if (actionType == 'ok') {

          let changedMember = formData.getRawValue()
          delete changedMember.comments

          if (!changedMember.image) {
            delete changedMember.image
          }

          if (!changedMember.text) {
            delete changedMember.text
          }

          console.log(JSON.stringify(changedMember))

          this._memberTempService.moveToMember(changedMember)

        }

      });

  }

  loadProducts () {
    this._productService.selectProducts()
      .subscribe((result) => {

        result.forEach((item) => {
          //  if (item.payload.doc.data().active) {

          let product = new Product();
          product.id = item.payload.doc.id;
          product.name = item.payload.doc.data().name;
          product.text = item.payload.doc.data().text;
          product.image = item.payload.doc.data().image;
          product.active = item.payload.doc.data().active;
          this.arrayProducts.push(product)
          //   }
        })

        // console.log("arrayProducts: " + JSON.stringify(this.arrayProducts))
      })
  }

  selectOrdersByProduct (event) {

    console.log(event)

    this._dashService.getOrigins(event)
    this._dashService.getRefundList(event)
    this._dashService.getWaitingList(event)

  }

  compareNames (a: any, b: any) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  /*
  loadMembers () {

    this._memberService.select()
      .subscribe((result) => {
        this.arrayMembers = []

        result.forEach((item) => {
          let member: any = {}

          if (item.payload.doc.data().name !== '') {
            member.id = item.payload.doc.id
            member.name = item.payload.doc.data().name
            this.arrayMembers.push(member)
          }

        })

        this.getPendingAnnotations()

      })
  }
  */


  getPendingAnnotations () {

    this._annotationService.selectPending()
      .subscribe((result) => {
        let arrayAnnotations: Annotation[] = []

        result.forEach((item) => {
          let dt: any = item.payload.doc.data().date
          let annotation = new Annotation()
          annotation.id = item.payload.doc.id
          annotation.date = dt.toDate()
          annotation.text = item.payload.doc.data().text
          annotation.member_id = item.payload.doc.data().member_id
          annotation.member_name = item.payload.doc.data().member_name
          annotation.status = item.payload.doc.data().status
          arrayAnnotations.push(annotation)
        })

        this.annotationDataSource = new MatTableDataSource(arrayAnnotations);
      })
  }

  openAnnotationDialog (entity) {

    let data: Annotation = new Annotation();

    if (entity) {
      data = entity;
    }

    let dialogRef = this.dialog.open(MemberAnnotationDialogComponent, {
      width: '600px',
      height: '470px',
      panelClass: 'custom-dialog-container',
      data: data
    });


    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];
      const data = this._annotationService.createAnnotation(formData.getRawValue())

      console.log("action: " + JSON.stringify(action))

      if (action === "edit") {
        this._annotationService.update(data)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log("Erro: " + err.message)
          })
      }

    })

  }

  deleteAnnotation (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "Excluir esta anotação?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._annotationService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete annotation error: " + error.message)}
          )
      }
    })
  }

  public agenda: any[] = [];
  public activities: any[] = [];
  public topics: any[] = [];
  public members: any[] = [];

  loadAgenda () {
    this._checkAgendaService.loadAgenda()
      .subscribe((result) => {
        result.forEach((i) => {
          this.agenda.push({'id': i.id, ...i.data()})
        })
        //this.loadStaff()
        this.loadActivities()
      })
  }

  loadStaff () {
    this._checkAgendaService.loadStaff()
      .subscribe((result) => {
        result.forEach((i) => {
          this.members.push({'id': i.id, 'name': i.data().name})
        })
        //console.log(JSON.stringify(this.members))
        //this.checkAgenda()
      })
  }

  loadActivities () {
    this._checkAgendaService.loadActivities()
      .subscribe((result) => {
        result.forEach((i) => {
          this.activities.push({'id': i.id, ...i.data()})
        })
        this.loadTopics()
        //this.checkAgenda()
        //console.log(JSON.stringify(this.activities))
      })
  }

  loadTopics () {
    this._checkAgendaService.loadTopics()
      .subscribe((result) => {
        result.forEach((i) => {
          this.topics.push({'id': i.id, ...i.data()})
        })
        this.checkAgenda()
        //console.log(JSON.stringify(this.topics))
      })
  }

  checkAgenda () {

    this.agenda.forEach((ag) => {

      /*
      if (ag.level === 'a') {

        const agAct = this.activities.find((e) => {
          return ag.activity_id === e.id
        })

        if (agAct) {
          if (agAct.name !== ag.activity_name) {
            console.log(agAct.name)
            console.log(ag.activity_name)
          } else {
            console.log('ok')
          }
        } else {
          console.log("não achou atividade: " + ag.activity_name)
        }

      }
      */

      //////////////////////////////


      if (ag.level === 't') {

        const agTopic = this.topics.find((e) => {
          return ag.topic_id === e.id
        })

        if (agTopic) {
          if (agTopic.name !== ag.topic_name) {
            console.log('topico: ' + agTopic.name)
            console.log('agenda day: ' + ag.day_name)
            console.log('agenda act: ' + ag.activity_name)
            console.log('agenda top: ' + ag.topic_name)

          }
        } else {
          console.log("não achou topico: " + ag.topic_name)
        }

      }



      /*
      const agStaff = this.members.find((e) => {
        return ag.member_id === e.id
      })

      if (agStaff) {
        if (agStaff.name !== ag.member_name) {
          console.log('staff : ' + agStaff.name)
          console.log('agenda: ' + ag.member_name)
          //console.log('day: ' + ag.day_name)
          //console.log('act: ' + ag.activity_name)
          //console.log('top: ' + ag.topic_name)
        }
      } else {
        console.log(">>>>>> não achou staff: " + ag.member_name)
      }
      */

    })

    console.log('==================================================')
  }

  getMembersDataChanges () {
    this._dashService.getMembersDataChanges().subscribe(result => {
      const docs = result;
      const array: any[] = []

      docs.forEach((doc: any) => {
        const item: any = {};
        item.name = doc.memberName;
        item.timestamp = doc.timestamp.toDate();
        const changes: any[] = [];

        Object.entries(doc.changedFields).forEach(([ campo, dados ]: [ string, any ]) => {
          const campoFormat = this.formatCampo(campo);
          changes.push({ [campoFormat]: {antes: dados.old, depois: dados.new}});
        });

        item.changes = changes;
        array.push(item);
      });

      // console.log(JSON.stringify(array))
      this.changesMembnersDataSource = new MatTableDataSource(array);

    })
  }

  formatCampo (field: string): string {
    var result: string = ""
    switch (field) {
      case 'shortName':
        result = "Apelido";
        break;
      case 'sex':
        result = "Gênero";
        break;
      case 'email':
        result = "Email";
        break;
      case 'email2':
        result = "Email-2";
        break;
      case 'dateBirth':
        result = "Nascimento";
        break;
      case 'clinicPhone':
        result = "Telefone-2";
        break;
      case 'crm':
        result = "CRM";
        break;
      case 'crmUF':
        result = "CRM-UF";
        break;
      case 'text':
        result = "Currículo";
        break;
      case 'address':
        result = "Endereço";
        break;
      case 'number':
        result = "Número";
        break;
      case 'complement':
        result = "Complemento";
        break;
      case 'city':
        result = "Cidade";
        break;
      case 'country':
        result = "País";
        break;
      case 'state':
        result = "Estado";
        break;
      case 'district':
        result = "Bairro";
        break;
      case 'postalCode':
        result = "CEP";
        break;
      case 'image':
        result = "Foto";
        break;
      default:
        result = field;
        break;
    }
    return result;

  }

  openChangesDialog (element) {

    this.dialogRef = this.dialog.open(MemberSiteChangedDialogComponent, {
      maxWidth: '600px',
      height: '500px',
      panelClass: 'custom-dialog-container',
      data: element
    });

  }






}
